import {SeparationOfDutyRole} from "./separationOfDutyRole";

export class SeparationOfDuty {
  separationOfDutyId: number;
  name?: string;
  separationOfDutyRoles?: SeparationOfDutyRole[];
}
